import { render, staticRenderFns } from "./RelevanceRankingStatus.vue?vue&type=template&id=2f27027d&scoped=true&"
import script from "./RelevanceRankingStatus.vue?vue&type=script&lang=js&"
export * from "./RelevanceRankingStatus.vue?vue&type=script&lang=js&"
import style0 from "./RelevanceRankingStatus.vue?vue&type=style&index=0&id=2f27027d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27027d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
